import React from 'react';
import { Button, Stack, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, TextField, Typography, InputLabel, Select, MenuItem, IconButton } from '@mui/material';
import { useParameterizedQuery } from 'react-fetching-library';

import { validateOrderNumberAction, getOrderOptionsAction } from '../../../../services/request';
import { invoiceTypes } from '../../../../services/constants';
import SearchOrderModal from './SearchOrderModal';

import SearchIcon from '@mui/icons-material/Search';

export const DocumentTypeDialogContent = props => {
  const { createSignal } = props;
  const { query } = useParameterizedQuery(validateOrderNumberAction);
  const [value, setValue] = React.useState('manual');
  const [orderNumber, setOrderNumber] = React.useState('');
  const [orderData, setOrderData] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [documentType, setDocumentType] = React.useState(5);
  const [open, handleOpen] = React.useState(false);

  const handleOrderValidation = async () => {
    if (value == 'order') {
      const { loading, payload, error } = await query(orderNumber);
      if (!loading, !error) {
        if (payload.success) {
          setOrderData(payload.order);
          setErrorMessage('');
          createSignal(payload.order, invoiceTypes.find(x => x.code == documentType), false);
        } else {
          setErrorMessage(`Zamówienie o numerze ${orderNumber} nie istnieje`);
        }
      } else {
        setErrorMessage('Coś poszło nie tak. Spróbuj jeszcze raz');
      }
    } else {
      setErrorMessage('');
      createSignal([], invoiceTypes.find(x => x.code == documentType), true);
    }
  };

  return (
    <>
      <FormControl sx={{ pt: 1, pb: 1, pl: 4, pr: 4 }}>
        <FormLabel>Wybierz rodzaj dokumentu</FormLabel>
        <RadioGroup
          defaultValue={value}
          value={value}
          onChange={e => setValue(e.target.value)}
        >
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="column">
              <FormControlLabel value="manual" control={<Radio />} label="Wystaw ręcznie" />
              <FormControlLabel value="order" control={<Radio />} label="Podepnij pod zamówienie" />
            </Stack>
            <Stack>
              <FormControl fullWidth sx={{ width: 300, mb: 1 }}>
                <InputLabel id="demo-simple-select-label">Typ dokumentu</InputLabel>
                <Select
                  value={documentType}
                  label="Typ dokumentu"
                  onChange={e => setDocumentType(e.target.value)}
                >
                  <MenuItem value={5}>Paragon</MenuItem>
                  <MenuItem value={6}>Paragon korygujący</MenuItem>
                  <MenuItem value={1}>Faktura</MenuItem>
                  <MenuItem value={2}>Faktura korygująca</MenuItem>
                  <MenuItem value={3}>Faktura proforma</MenuItem>
                  <MenuItem value={4}>Faktura do paragonu</MenuItem>
                  {/* <MenuItem value={7}>Faktura marża</MenuItem> */}
                  {/* <MenuItem value={8}>Paragon marża</MenuItem> */}
                  {/* <MenuItem value={9}>Faktura do paragonu marża</MenuItem> */}
                  <MenuItem value={10}>Faktura zaliczkowa</MenuItem>
                  <MenuItem value={11}>Nota obciążeniowa</MenuItem>
                </Select>
              </FormControl>
              { value == 'order'
                ? <Stack direction="row" spacing={2}>
                  <IconButton onClick={() => handleOpen(true)}>
                    <SearchIcon />
                  </IconButton>
                  <TextField
                    label="Podaj numer zamówienia"
                    value={orderNumber}
                    onChange={e => setOrderNumber(e.target.value)}
                    fullWidth
                  />
                  {open ? <SearchOrderModal setOrderNumber={setOrderNumber} handleClose={() => handleOpen(false)} /> : null}
                </Stack>
                : null}
            </Stack>
          </Stack>
        </RadioGroup>
        <Button onClick={handleOrderValidation}>Przejdź dalej</Button>
        {errorMessage
          ? <Typography color="error">{errorMessage}</Typography> : null}
      </FormControl>
    </>
  );
};
